import { BOX_SHADOW_THEME } from "../../../../../utils/colors";

export const PERFORMING_ASSETS_HAIRLINE = "#E6EBF1";
export const PERFORMING_ASSETS_BLUE = "#2563EB";
export const PERFORMING_ASSETS_BLUE_SOFT = "#BFDBFE";

export const PERFORMING_ASSETS_CARD_SX = {
  bgcolor: "#fff",
  border: `1px solid ${PERFORMING_ASSETS_HAIRLINE}`,
  borderRadius: "18px",
  boxShadow: BOX_SHADOW_THEME,
  p: 2.5,
  minWidth: 0,
  display: "flex",
  flexDirection: "column",
};

export const PERFORMING_ASSETS_TITLE_SX = {
  m: 0,
  fontSize: "0.9375rem",
  fontWeight: 600,
  color: "text.primary",
  lineHeight: 1.35,
};

export const PERFORMING_ASSETS_EYEBROW_SX = {
  m: 0,
  fontSize: "0.75rem",
  fontWeight: 600,
  color: "fields.placeholder",
  lineHeight: 1.4,
};

export const PERFORMING_ASSETS_METRIC_VALUE_SX = {
  mt: 0.25,
  fontSize: "1.125rem",
  fontWeight: 600,
  lineHeight: 1.3,
  color: "text.primary",
  fontVariantNumeric: "tabular-nums",
};
